"use strict";

export default function filterGroups(items, groupName) {
	if (!items)
		return null;
	
	return items.filter(function(item){
		return !/.Group$/.test(item.type);
	});
}


// WEBPACK FOOTER //
// ./~/vwa/utils/filterGroups.js